import cn from "classnames";
import { Upload } from "antd";
import type { UploadChangeParam, UploadFile } from "antd/es/upload/interface";
import { InboxOutlined } from "@ant-design/icons";

import style from "./SingleFileDragger.module.css";

const { Dragger } = Upload;

export type SingleFileDraggerProps = {
  id?: string;
  /** Controlled by Form.Item via `valuePropName="file"`. */
  file?: UploadFile;
  /** Form.Item's default trigger; receives the new file (or undefined when cleared). */
  onChange?: (file: UploadFile | undefined) => void;
  accept: string;
  hintText?: string;
  className?: string;
};

export function SingleFileDragger({ id, file, onChange, accept, hintText, className }: SingleFileDraggerProps) {
  const handleChange = (info: UploadChangeParam<UploadFile>) => {
    onChange?.(info.fileList[0]);
  };

  return (
    <Dragger
      id={id}
      accept={accept}
      maxCount={1}
      beforeUpload={() => false /* prevent auto-upload; the file is sent manually on submit */}
      className={cn(style.uploadDragger, className)}
      fileList={file ? [file] : []}
      onChange={handleChange}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">Drag and drop file here, or click to browse</p>
      {hintText && <p className="ant-upload-hint">{hintText}</p>}
    </Dragger>
  );
}
